import Vue from "vue";
import router from "../router";
import store from "../store";
import notification from "ant-design-vue/es/notification";
import NProgress from "nprogress";
import {
  ACCESS_TOKEN,
  ACCOUNT_TYPE,
  ACCOUNT_TYPE_INFO
} from "../store/mutaion-types";
import { setDocumentTitle, domTitle } from "@/utils/domUtil";
const whiteList = ["login", "adminLogin", "register", "registerResult"];
//普通用户默认页面
const defaultRoutePath = "/dashboard/workplace";
//系统管理用户默认界面
const systemDefaultRoutePath = "/dashboard/control";

router.beforeEach((to, from, next) => {
  //(开始进度条)
  NProgress.start();
  if (to.meta && typeof to.meta.title !== "undefined") {
    //设置标题
    setDocumentTitle(`${to.meta.title} - ${domTitle}`);
  }
  let accountType = Vue.ls.get(ACCOUNT_TYPE);
  let toPath = "user";
  if (accountType == ACCOUNT_TYPE_INFO.SYSTEM) {
    toPath = "admin";
  }
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* 如果存在token */
    if (to.path === "/user/login") {
      next({
        path: defaultRoutePath
      });
      NProgress.done();
    } else if (to.path === "/admin/adminLogin") {
      next({
        path: systemDefaultRoutePath
      });
      NProgress.done();
    } else {
      if (store.getters.permissions.length === 0) {
        store
          .dispatch("GetInfo")
          .then(res => {
            const permsissions = res.perms;
            // console.log("权限信息:" + JSON.stringify(permsissions));
            //获取路由信息
            store
              .dispatch("GenerateRoutes", {
                permsissions
              })
              .then(() => {
                // console.log("角色");
                // console.log(roles);
                // 根据roles权限生成可访问的路由表
                // 动态添加可访问路由表
                router.addRoutes(store.getters.addRouters);
                // console.log(store.getters.addRouters);
                // 请求带有 redirect 重定向时，登录自动重定向到该地址
                const redirect = decodeURIComponent(
                  from.query.redirect || to.path
                );
                if (to.path === redirect) {
                  // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                  next({ ...to, replace: true });
                } else {
                  // 跳转到目的路由
                  next({
                    path: redirect
                  });
                }
              });
          })
          .catch(() => {
            notification.error({
              message: "错误",
              description: "请求用户信息失败，请重试"
            });
            store.dispatch("Logout").then(() => {
              next({
                name: toPath,
                query: {
                  redirect: to.fullPath
                }
              });
            });
          });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next();
    } else {
      // console.log(to);
      // console.log("路由的全路径:" + to.fullPath);
      next({
        name: toPath
        // query: {
        //   redirect: to.fullPath
        // }
      });
      //如果当前页面是登录后不会触发每个钩子，所以手动处理它
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  //完成加载
  NProgress.done();
});
